export default import.meta.ROLLDOWN_FILE_URL_N6LRfLEfghGa73qxwBQcwg